import React, { FC, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";
import moment from "moment";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { PeriodIndexTypes, PeriodTypesArray } from "../../services/enums";
import HighChartsService from "../../services/highcharts.service";
import { IResultResponse } from "../../models/response/result.model";
import ChartRangeSelector from "../CI10/ChartRangeSelector";
import { MomentumPeriod, IMomentum } from "../../models/fearAndGreed/momentum.model";

const MomentumChart: FC = () => {
  const [periodIndex, setPeriodIndex] = useState(PeriodIndexTypes["1m"]);

  const { fetchedData, loading } = useHttpGet<IResultResponse<IMomentum[]>>(
    `${APIRoutes.FEAR_AND_GREED}/momentum/${PeriodTypesArray[periodIndex]}`, { dependencies: [periodIndex] }
  );

  const getOptions = (data: IMomentum = {} as IMomentum) => {
    return {
      ...HighChartsService.baseSettings({
        series: [
          {
            name: '10 Days Momentum',
            data:
              CommonService.sortByDate(fetchedData?.result?.filter(f => f.period == MomentumPeriod.Momentum10Days))?.map(
                (el: IMomentum) => [moment(el?.date).unix(), el?.value]
              ) || [],
          },
          {
            name: '5 Days Momentum',
            data:
              CommonService.sortByDate(fetchedData?.result?.filter(f => f.period == MomentumPeriod.Momentum5Days))?.map(
                (el: IMomentum) => [moment(el?.date).unix(), el?.value]
              ) || [],
          },
        ],
      }),
      xAxis: {
        type: "datetime",
        crosshair: true,
        labels: {
          formatter: function () {
            const th: any = this;
            return moment.unix(th?.value).format("MM/DD/YYYY");
          },
        },
      },
      tooltip: {
        shared: true,
        formatter() {
          const th: any = this;

          let s: any = `${moment.unix(th?.x).format("MM/DD/YYYY")}`;

          th?.points?.forEach((point: any) => {
            s += `<br/>${point?.y > 0 ? 'Bullish' : 'Bearish'}: ${CommonService.toLocalNum(
              point?.y
            )}`;
          });
          return s;
        },
      },
    };
  };

  return (
    <Spin spinning={loading}>
      <ChartRangeSelector
        show1Day={false}
        periodIndex={periodIndex}
        setPeriodIndex={setPeriodIndex}
      />
      <HighchartsReact
        highcharts={Highcharts}
        options={getOptions()}
      />
    </Spin>
  );
};

export default MomentumChart;
